import PropTypes from "prop-types";
import BookingAccommodation from "app/pages/PrePackage/rental/BookingAccommodation";
import "./booking-rental-accommodations.scss";

const BookingRentalAccommodationList = ({
	rentalAccommodations = [],
	field,
	onRentalAccommodationChange,
}) => {
	let rentalAccommodationsNode = rentalAccommodations.map((rentalAccommodation, index) => {
		return (
			<div key={rentalAccommodation.accommodation} className="rental-accommodations__item">
				<BookingAccommodation
					id={`${rentalAccommodation.accommodation}`}
					rentalAccommodation={rentalAccommodation}
					field={field}
					onChange={onRentalAccommodationChange}
					data-testid={`search-engine-accommodation-${index}`}
				/>
			</div>
		);
	});

	return <div className="rental-accommodations">{rentalAccommodationsNode}</div>;
};

BookingRentalAccommodationList.propTypes = {
	rentalAccommodations: PropTypes.array,
	field: PropTypes.object,
	onRentalAccommodationChange: PropTypes.func,
};

export default BookingRentalAccommodationList;
